/**
 * Allows you to add data-method="METHOD to links to automatically inject a form
 * with the method on click
 *
 * Example: <a href="{{route('customers.destroy', $customer->id)}}"
 * data-method="delete" name="delete_item">Delete</a>
 *
 * Injects a form with that's fired on click of the link with a DELETE request.
 * Good because you don't have to dirty your HTML with delete forms everywhere.
 *
 * Tom added 2020.01.25
 * Policy not to use jquery as much as possible
 *
 */
/*
function addDeleteForms() {
    $('[data-method]').append(function () {
        if (!$(this).find('form').length > 0) {
            return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                "<input type='hidden' name='_method' value='" + $(this).attr('data-method') + "'>\n" +
                "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                '</form>\n';
        } else { return '' }
    })
        .attr('href', '#')
        .attr('style', 'cursor:pointer;')
        .attr('onclick', '$(this).find("form").submit();');
}
*/

/**
 * Place any jQuery/helper plugins in here.
 *
 * Tom added 2020.01.25
 * Policy not to use jquery as much as possible
 */
$(function () {
    /**
     * Add the data-method="delete" forms to all delete links
     */
    //addDeleteForms();

    /**
     * Disable all submit buttons once clicked
     */
    /*
    $('form').submit(function () {
        $(this).find('input[type="submit"]').attr('disabled', true);
        $(this).find('button[type="submit"]').attr('disabled', true);
        return true;
    });
    */

    /**
     * Generic confirm form delete using Sweet Alert
     */
    /*
    $('body').on('submit', 'form[name=delete_item]', function (e) {
        e.preventDefault();

        const form = this;
        const link = $('a[data-method="delete"]');
        const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
        const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Yes, delete';
        const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to delete this item?';

        Swal.fire({
            title: title,
            showCancelButton: true,
            confirmButtonText: confirm,
            cancelButtonText: cancel,
            icon: 'warning'
        }).then((result) => {
            result.value && form.submit();
        });
    }).on('click', 'a[name=confirm_item]', function (e) {
    */
        /**
         * Generic 'are you sure' confirm box
         */
    /*
        e.preventDefault();

        const link = $(this);
        const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to do this?';
        const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
        const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Continue';

        Swal.fire({
            title: title,
            showCancelButton: true,
            confirmButtonText: confirm,
            cancelButtonText: cancel,
            icon: 'info'
        }).then((result) => {
            result.value && window.location.assign(link.attr('href'));
        });
    });
    */

    //$('[data-toggle="tooltip"]').tooltip();
});

/**
 * Allows you to add data-method="METHOD to links to automatically inject a form
 * with the method on click
 *
 * Example: <a href="{{route('customers.destroy', $customer->id)}}"
 * data-method="delete" name="delete_item">Delete</a>
 *
 * Injects a form with that's fired on click of the link with a DELETE request.
 * Good because you don't have to dirty your HTML with delete forms everywhere.
 */
function addDeleteForms() {

    document.querySelectorAll('[data-method]').forEach( dom => {
        const forms = dom.querySelectorAll('form');
        if(!(forms.length > 0)) {
            const methodInput = document.createElement('input');
            methodInput.setAttribute('type', 'hidden');
            methodInput.setAttribute('name', '_method');
            methodInput.setAttribute('value', dom.getAttribute('data-method'));

            const tokenInput = document.createElement('input');
            tokenInput.setAttribute('type', 'hidden');
            tokenInput.setAttribute('name', '_token');
            const token = document.head.querySelector('meta[name="csrf-token"]');
            tokenInput.setAttribute('value', token.content);

            const form = document.createElement('form');
            form.setAttribute('action', dom.getAttribute('href'));
            form.setAttribute('method', 'POST');
            form.setAttribute('name', 'delete_item');
            form.setAttribute('style', 'display:none;');
            form.appendChild(methodInput);
            form.appendChild(tokenInput);

            dom.appendChild(form);
            dom.setAttribute('href', '#');
            dom.setAttribute('style', 'cursor:pointer;');

            dom.addEventListener('click', event => {
                event.preventDefault();

                const form = event.currentTarget.querySelector('form');
                const cancel = event.currentTarget.getAttribute('data-trans-button-cancel') || 'Cancel';
                const confirm = event.currentTarget.getAttribute('data-trans-button-confirm') || 'Yes, delete';
                const title = event.currentTarget.getAttribute('data-trans-title') || 'Are you sure you want to delete this item?';

                Swal.fire({
                    title: title,
                    showCancelButton: true,
                    confirmButtonText: confirm,
                    cancelButtonText: cancel,
                    icon: 'warning'
                }).then((result) => {
                    console.log(result);
                    result.value && form.submit();
                });
            });
        }
    });
}

/**
 * for Bulma <https://bulma.io/>
 * and
 * for anti jQuery
 */
document.addEventListener('DOMContentLoaded', () => {
    /**
     * Add the data-method="delete" forms to all delete links
     */
    addDeleteForms();

    /**
     * Buger Menu
     */
    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {

        // Add a click event on each of them
        $navbarBurgers.forEach( el => {
            el.addEventListener('click', () => {

                // Get the target from the "data-target" attribute
                const target = el.dataset.target;
                const $target = document.getElementById(target);

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                el.classList.toggle('is-active');
                $target.classList.toggle('is-active');

            });
        });
    }

    /**
     * Disable all submit buttons once clicked
     */
    document.querySelectorAll('form').forEach( form => {
        form.addEventListener('submit', event => {
            event.target.querySelectorAll('[type=submit]').forEach( submitBtn => {
                submitBtn.setAttribute('disabled', true);
            });
            return true;
        });
    });


    /**
     * Generic 'are you sure' confirm box
     */
    document.querySelectorAll('a[name=confirm_item]').forEach( a => {
        a.addEventListener('click', event => {
            event.preventDefault();

            const cancel = event.currentTarget.getAttribute('data-trans-button-cancel') || 'Cancel';
            const confirm = event.currentTarget.getAttribute('data-trans-button-confirm') || 'Continue';
            const title = event.currentTarget.getAttribute('data-trans-title') || 'Are you sure you want to do this?';
            const link = event.currentTarget.getAttribute('href');

            Swal.fire({
                title: title,
                showCancelButton: true,
                confirmButtonText: confirm,
                cancelButtonText: cancel,
                icon: 'info'
            }).then((result) => {
                result.value && window.location.assign(link);
            });
        });
    } );


    /**
     * Delete Notification element when Notification Close button clicked.
     */
    (document.querySelectorAll('.notification .delete') || []).forEach( deleteBtn => {
        const notification = deleteBtn.parentNode;
        deleteBtn.addEventListener('click', () => {
            notification.parentNode.removeChild(notification);
        });
    });


    /**
     * When tab is clicked, display contents are switched.
     */
    document.querySelectorAll('div.tabs > ul > li > a').forEach( a => {
        a.addEventListener('click', event => {
            event.preventDefault();
            if(!event.currentTarget.parentNode.classList.contains('is-active')) {
                //Close opened content
                const closeTabPane = document.querySelector('.tab-content > .is-active');
                if(closeTabPane.classList.contains('is-active'))  closeTabPane.classList.remove('is-active');
                if(!closeTabPane.classList.contains('is-hidden')) closeTabPane.classList.add('is-hidden');
                //Open clicked content
                const openTabPane = document.querySelector('.tab-content > '+event.currentTarget.hash);
                if(openTabPane.classList.contains('is-hidden'))  openTabPane.classList.remove('is-hidden');
                if(!openTabPane.classList.contains('is-active')) openTabPane.classList.add('is-active');
                //Switch tab
                document.querySelector('div.tabs > ul > li.is-active').classList.remove('is-active');
                event.currentTarget.parentNode.classList.add('is-active');
            }
        });
    });

});

